import React, { useEffect } from "react";
import { any } from "prop-types";

import { PopupButton } from "@typeform/embed-react";

import CoverPorfolio from "../../components/cover-portfolio";

import { LargeText } from "../../ui-components/texts";

import PeopleOfMasamune from "../../components/people-of-masamune";
import { DetailsProject } from "../../components/portfolio-components";

// images
import imageCover from "../../media/images/portfolio-images/ofit/image-cover.jpg";

import {
	TitleWithScrollXImagesSection,
} from "./components-design";
import { useTranslate } from "../../contexts/translate";

const Ofit = ({ setNextPageHref = () => {}, setNextPageName = () => {} }) => {
	const { translations } = useTranslate();

	useEffect(() => {
		setNextPageHref("/projects/antonio-quaglietta");
		setNextPageName("Antonio Quaglietta");
		document.title = 'Ofit - Cutting Edge Digital Creative Studio'
	}, []);

	const peoples = [
		{
			fullname: "Giuseppe Bussolari",
			image: require("../../media/team-images/Giuseppe Bussolari.jpg").default,
			role: translations === null ? "" : translations.about.peoples[8].role,
			description:
				translations === null ? "" : translations.about.peoples[8].description,
		},
		{
			fullname: "Simone Ruiz",
			image: require("../../media/team-images/Simone Ruiz.jpg").default,
			role: translations === null ? "" : translations.about.peoples[1].role,
			description:
				translations === null ? "" : translations.about.peoples[1].description,
		},
	];

	return (
		<div className="project-page project-page-us-lecce">
			<CoverPorfolio
				background="#f9ebda"
				title="Ofit"
				text={translations && translations.ofit.intro}
				image={imageCover}
			/>

			<DetailsProject
				client={"Ofit"}
				services={["Brand Identity", "Photography"]}
				timeframe={"2019"}
				introduction={
					<>
						<LargeText>
							{translations && translations.ofit.descriptions[0]}
						</LargeText>
						<LargeText>
							{translations && translations.ofit.descriptions[1]}
						</LargeText>
						<LargeText>
							{translations && translations.ofit.descriptions[2]}
						</LargeText>
					</>
				}
			/>

			<TitleWithScrollXImagesSection
				className={'theme-dark'}
				color={"#fbce96"}
				title={translations && translations.ofit.sections[0].title}
				text={translations && translations.ofit.sections[0].text}
				items={[
					{ src: require('../../media/images/portfolio-images/ofit/image-1.jpg').default },
					{ src: require('../../media/images/portfolio-images/ofit/image-2.jpg').default },
					{ src: require('../../media/images/portfolio-images/ofit/image-3.jpg').default },
					{ src: require('../../media/images/portfolio-images/ofit/image-4.jpg').default },
				]}
			/>

			<TitleWithScrollXImagesSection
				color={"#fff"}
				white={false}
				className="mb-0 pb-0 theme-light"
				title={translations && translations.ofit.sections[1].title}
				text={translations && translations.ofit.sections[1].text}
				items={[
					{ src: require('../../media/images/portfolio-images/ofit/gallery/1.jpg').default },
					{ src: require('../../media/images/portfolio-images/ofit/gallery/2.jpg').default },
					{ src: require('../../media/images/portfolio-images/ofit/gallery/3.jpg').default },
					{ src: require('../../media/images/portfolio-images/ofit/gallery/4.jpg').default },
				]}
			/>

			<PeopleOfMasamune peoples={peoples} />
					<div className="cta-single-project">
				<div className="cta-single-project-inner">
					<p>{translations && translations.ctasingleproject.text}</p>
					<button
						className="leadconnector-button"
						onClick={() => {
							const overlay = document.createElement("div");
							overlay.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													background-color: rgba(0, 0, 0, 0.7);
													backdrop-filter: blur(5px);
													z-index: 9998;
												`;

							const modal = document.createElement("div");
							modal.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													z-index: 9999;
												`;

							const closeBtn = document.createElement("button");
							closeBtn.innerHTML = "✕";
							closeBtn.style.cssText = `
													position: fixed;
													top: 30px;
													right: 30px;
													width: 50px;
													height: 50px;
													border: none;
													background-color: rgba(255, 255, 255, 0.2);
													color: white;
													border-radius: 50%;
													cursor: pointer;
													font-size: 28px;
													z-index: 10000;
													transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
													backdrop-filter: blur(10px);
													border: 1px solid rgba(255, 255, 255, 0.3);
													display: flex;
													align-items: center;
													justify-content: center;
												`;
							closeBtn.onmouseover = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
								closeBtn.style.transform = "scale(1.15) rotate(90deg)";
								closeBtn.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.3)";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.5)";
							};
							closeBtn.onmouseout = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
								closeBtn.style.transform = "scale(1) rotate(0deg)";
								closeBtn.style.boxShadow = "none";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.3)";
							};
							closeBtn.onclick = () => {
								overlay.style.opacity = "0";
								modal.style.opacity = "0";
								overlay.style.transition = "opacity 0.4s ease-out";
								modal.style.transition = "opacity 0.4s ease-out";
								setTimeout(() => {
									document.body.removeChild(overlay);
									document.body.removeChild(modal);
								}, 400);
							};

							const iframe = document.createElement("iframe");
							iframe.src =
								"https://api.leadconnectorhq.com/widget/survey/fXRdOm9p3aM4iNGpHfOa?notrack=true";
							iframe.style.cssText = `
													width: 100%;
													height: 100%;
													border: none;
												`;
							iframe.allowFullscreen = true;

							modal.appendChild(iframe);
							modal.appendChild(closeBtn);
							document.body.appendChild(overlay);
							document.body.appendChild(modal);

							overlay.onclick = () => {
								document.body.removeChild(overlay);
								document.body.removeChild(modal);
							};
						}}
					>
						{translations && translations.ctasingleproject.button}
					</button>
				</div>
			</div>
		</div>
	);
};

Ofit.propTypes = {
	setNextPageHref: any,
	setNextPageName: any,
};

export default Ofit;
